/* eslint-disable no-unused-vars */
import { Card, Grid, IconButton, Popover } from "@mui/material";
import { green, red, yellow } from "@mui/material/colors";
import BackspaceIcon from "@mui/icons-material/Backspace";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StringUtils } from "../../../utils/StringUtils";
import PConfirm from "../../../components/pos/PConfirm";

export default function PaymentItems(props) {
  const { t } = useTranslation();
  const translate = t;
  const [panelData, setPanalData] = useState([]);
  const [toPay, setToPay] = useState(props.total);
  const [settleFlag, setSettleFlag] = useState("R");
  const [anchorElement, setAnchorElement] = useState(null);
  const [showPaycodeRemove, setShowPaycodeRemove] = useState(true);
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  props.pRefs.paymentItem = {
    parentEvent: parentEvent,
  };

  const settlePanelColor = {
    R: { background: red[700], textColor: "white" },
    G: { background: green[700], textColor: "white" },
    Y: { background: yellow[700], textColor: "black" },
  };

  function parentEvent(event, setEnableSaleSave, buttonIndex) {
    console.log("Event Received in Payment Items" + event);
    if (event === "Save" || event === "Print") {
      console.log(settleFlag);
      if (settleFlag == "Y") {
        props.onSave(event, null, buttonIndex);
      } else {
        if (props.saleType === "SALE_ORDER") {
          validateSaleOrder(setEnableSaleSave, event);
        } else if (props.saleType === "SERVICE") {
          validateService(setEnableSaleSave, event);
        } else {
          console.log("Showing Alert");
          props.setAlert({
            show: true,
            title: translate("Alert!"),
            message: translate(
              "Please Settle the amount before proceeding . Did you forget to press Enter?"
            ),
          });
          setEnableSaleSave(true);
        }
      }
    } else if (event === "showPaymentCard") {
      let gridElement = document.getElementById("payCardGrid item");
      if (gridElement && props.isMobile) {
        setAnchorElement(gridElement);
        setShowPaycodeRemove(false);
        setTimeout(function () {
          setAnchorElement(null);
          setShowPaycodeRemove(true);
        }, 2000);
      }
    } else if (event === "settled") {
      setSettleFlag("G");
    } else if (event === "isSettled") {
      return settleFlag === "G";
    }
  }

  useEffect(() => {
    refreshCard();
  }, [props.paymentData]);

  useEffect(() => {
    setToPay(props.total);
    if (props.total == 0) {
      setSettleFlag("Y");
    } else {
      setSettleFlag("R");
    }
  }, [props.total]);

  function validateSaleOrder(setEnableSaleSave, event) {
    let total = 0;
    for (let d of props.paymentData) {
      total = total + parseFloat(d.amount);
    }
    if (total > 0) {
      setConfirmOpen(true);
      setConfirmContext({
        title: "Are You Sure",
        message:
          "Are you sure to create " +
          (props.context.storeAdmin.saleOrderName
            ? props.context.storeAdmin.saleOrderName
            : "Sale Order") +
          " with Partial Payment",
        type: "warning",
        open: true,
        yes: true,
        no: true,
        setEnableSaleSave: setEnableSaleSave,
        event: event,
      });
    } else {
      setConfirmOpen(true);
      setConfirmContext({
        title: "Are You Sure",
        message:
          "Are you sure to create " +
          (props.context.storeAdmin.saleOrderName
            ? props.context.storeAdmin.saleOrderName
            : "Sale Order") +
          " with Zero Payment",
        type: "warning",
        open: true,
        yes: true,
        no: true,
        setEnableSaleSave: setEnableSaleSave,
        event: event,
      });
    }
  }

  function validateService(setEnableSaleSave, event) {
    let total = 0;
    for (let d of props.paymentData) {
      total = total + parseFloat(d.amount);
    }
    if (total > 0) {
      setConfirmOpen(true);
      setConfirmContext({
        title: "Are You Sure",
        message: "Are you sure to create Service Order with Partial Payment",
        type: "warning",
        open: true,
        yes: true,
        no: true,
        setEnableSaleSave: setEnableSaleSave,
        event: event,
      });
    } else {
      setConfirmOpen(true);
      setConfirmContext({
        title: "Are You Sure",
        message: "Are you sure to create Service Order with Zero Payment",
        type: "warning",
        open: true,
        yes: true,
        no: true,
        setEnableSaleSave: setEnableSaleSave,
        event: event,
      });
    }
  }

  async function onYesNoClicked(context, value, contextType, callbackRef) {
    if ("yes" === value) {
      props.onSave(context.event);
      setConfirmOpen(false);
    }
    if ("no" === value) {
      console.log(context);
      setConfirmOpen(false);
      context.setEnableSaleSave(true);
    }
  }

  function refreshCard() {
    let total = 0;
    let toPayVar = 0;
    let newArr = [];
    for (let d of props.paymentData) {
      newArr.push({
        code: d.code,
        amount: StringUtils.formattedNumber(
          d.amount,
          props.context.store.currencyDecimal
        ),
        isFxApplied: d.isFxApplied,
      });
      total = total + parseFloat(d.amount);
    }
    newArr.push({
      code: translate("Total"),
      amount: StringUtils.formattedNumber(
        total,
        props.context.store.currencyDecimal
      ),
    });
    setToPay(
      StringUtils.formattedNumber(
        props.total - total,
        props.context.store.currencyDecimal
      )
    );
    if (
      parseFloat(props.total) -
        parseFloat(
          StringUtils.formattedNumber(
            total,
            props.context.store.currencyDecimal
          )
        ) ==
      0
    ) {
      setSettleFlag("Y");
    } else {
      setSettleFlag("R");
    }
    setPanalData(newArr);
  }

  function removePayCode(payCode) {
    let dat = [];

    for (let d of props.paymentData) {
      if (d.code !== payCode) {
        dat.push(d);
      }
    }
    console.log(payCode);
    console.log(dat);
    props.setPaymentData(dat);
  }

  function handleClosePopover() {
    setAnchorElement(null);
  }

  return (
    <div>
      <Grid container>
        <Grid
          id="payCardGrid item"
          item
          xs={12}
          onClick={(e) => {
            if (props.isMobile) setAnchorElement(e.currentTarget);
          }}
        >
          <Card
            style={{
              background: settlePanelColor[settleFlag].background,
              color: settlePanelColor[settleFlag].textColor,
            }}
          >
            <table style={{ width: "100%", padding: 5 }}>
              <tbody>
                {settleFlag == "R" && (
                  <tr>
                    <td>{translate("To Pay")}</td>
                    <td style={{ textAlign: "right" }}>
                      {toPay} {props.context.store.currency}
                    </td>
                  </tr>
                )}
                {settleFlag === "Y" && (
                  <tr>
                    <td>{translate("Ready to Settle")}</td>
                  </tr>
                )}
                {settleFlag === "G" && (
                  <tr>
                    <td>{translate("Settled")}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </Card>
        </Grid>
      </Grid>
      {!props.isMobile && (
        <Grid item xs={12}>
          <Card
            style={{
              height: "140px",
              marginTop: 5,
              marginBottom: 5,
              background: "#4a148c",
              color: "#fff",
              padding: 10,
              overflow: "auto",
            }}
          >
            <table style={{ width: "100%" }}>
              <tbody>
                {panelData.map((option, index) => (
                  <tr key={"payItem." + option.code}>
                    <td>
                      {option.code}
                      {option.isFxApplied && option.code != "Total"
                        ? " > " + props.context.store.currency
                        : ""}
                    </td>
                    <td style={{ textAlign: "right" }}>{option.amount}</td>
                    <td style={{ textAlign: "right", width: 30 }}>
                      {option.code != "Total" && option.code != "ADVANCE" && (
                        <IconButton
                          size="small"
                          style={{ color: "white", padding: 0 }}
                          onClick={() => {
                            removePayCode(option.code);
                          }}
                        >
                          <BackspaceIcon />
                        </IconButton>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </Grid>
      )}
      {props.isMobile && (
        <Popover
          open={anchorElement ? true : false}
          anchorEl={anchorElement}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Card
            style={{
              height: "140px",
              background: "#4a148c",
              color: "#fff",
              padding: 10,
              overflow: "auto",
            }}
          >
            <table style={{ width: "100%" }}>
              <tbody>
                {panelData.map((option, index) => (
                  <tr key={"payItem." + option.code}>
                    <td>
                      {option.code}
                      {option.isFxApplied && option.code != "Total"
                        ? " > " + props.context.store.currency
                        : ""}
                    </td>
                    <td style={{ textAlign: "right" }}>{option.amount}</td>
                    <td style={{ textAlign: "right", width: 30 }}>
                      {option.code != "Total" &&
                        option.code != "ADVANCE" &&
                        showPaycodeRemove && (
                          <IconButton
                            size="small"
                            style={{ color: "white", padding: 0 }}
                            onClick={() => {
                              removePayCode(option.code);
                            }}
                          >
                            <BackspaceIcon />
                          </IconButton>
                        )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </Popover>
      )}
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
